import { Loader2, AlertTriangle, RotateCcw } from "lucide-react";
import { Link } from "react-router-dom";
import { ASSETS } from "../../lib/assets";
import { useI18n } from "../../i18n/I18nProvider";

export function Loading({ label }) {
  const { t } = useI18n();
  return (
    <div role="status" aria-live="polite" data-testid="loading-state" className="flex flex-col items-center justify-center gap-3 py-16 text-[#17345F]/70">
      <Loader2 className="h-8 w-8 animate-spin text-[#237BE8]" aria-hidden />
      <span className="font-semibold">{label || t("common.loading")}</span>
    </div>
  );
}

export function Empty({ title, body, action, mascot = "pink", testid = "empty-state" }) {
  const m = ASSETS[mascot];
  return (
    <div data-testid={testid} className="flex flex-col items-center gap-4 rounded-[32px] border-2 border-dashed border-sky-200 bg-white/70 px-6 py-12 text-center">
      <img src={m.src} alt="" width={120} height={120} loading="lazy" className="h-28 w-28 object-contain animate-float" />
      <p className="font-heading text-lg font-extrabold text-[#17345F]">{title}</p>
      {body && <p className="max-w-md text-sm text-[#17345F]/70">{body}</p>}
      {action}
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  const { t } = useI18n();
  return (
    <div role="alert" data-testid="error-state" className="flex flex-col items-center gap-3 rounded-3xl bg-rose-50 px-6 py-10 text-center text-rose-700">
      <AlertTriangle className="h-8 w-8" aria-hidden />
      <p className="font-semibold">{message || t("common.error")}</p>
      <div className="flex gap-3">
        {onRetry && <button data-testid="error-retry-btn" onClick={onRetry} className="btn-pill bg-white text-rose-700"><RotateCcw className="h-4 w-4" />{t("common.retry")}</button>}
        <Link data-testid="error-home-link" to="/" className="btn-pill bg-white text-[#17345F]">{t("common.home")}</Link>
      </div>
    </div>
  );
}

export function LangNotice({ available = ["en"] }) {
  const { t, lang } = useI18n();
  if (available.includes(lang)) return null;
  return (
    <p data-testid="lang-notice" className="mb-6 inline-flex rounded-full bg-[#FFD84A]/40 px-4 py-1.5 text-sm font-semibold text-[#17345F]">
      {t("common.onlyIn")} {available.map((l) => t(`langName.${l}`)).join(", ")}
    </p>
  );
}
